import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ApiEndpoint } from '@shared/shared/enums/api-endpoints.enum';
import { UserLogout } from '@shared/store/user';
import { ErrorMessageService } from 'core/services/error-message.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class UnauthorisedResponseInterceptorService implements HttpInterceptor {
  constructor(private store: Store, private errorMessageService: ErrorMessageService, private router: Router) {}

  /**
   * Intercept responses with a 401 code
   * and delegate to a service to navigate to the login page.
   */
  public isException(url: string) {
    const exceptions = [ApiEndpoint.USER_AUTO_LOGIN, ApiEndpoint.REGISTRATION_TOKEN, ApiEndpoint.USER_LOGOUT];
    return exceptions.some((endpoint) => url.includes(endpoint));
  }

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap(
        () => {},
        (error: HttpErrorResponse) => {
          if (error.status === 401 && !this.isException(request.url)) {
            this.store.dispatch(new UserLogout());
            this.router.navigateByUrl('/user/login');
          } else {
            this.errorMessageService.displayErrorMessage(error);
          }
        }
      )
    );
  }
}
